import Translate from '../icons/Translate'
import React, { useEffect, useMemo, useState } from 'react'
import Loader from './Loader'

interface Props {
  message: string
  author: string
  groupMessageType: 'first' | 'last' | 'middle' | 'single'
  translateMessage: (messageId: number, message: string) => void
  id: number
  translated: boolean
}

const SentMessage = ({ message, groupMessageType, translateMessage, id, translated }: Props) => {
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    setIsLoading(false)
  }, [message, translated])

  const borderStyles = useMemo(() => {
    if (groupMessageType === 'first') return 'rounded-br-none'
    if (groupMessageType === 'last') return 'rounded-tr-none'
    if (groupMessageType === 'middle') return 'rounded-r-none'
    return 'rounded-2xl'
  }, [groupMessageType])

  return (
    <div className="px-2">
      <div className="flex justify-end items-center">
        <div
          onClick={() => {
            setIsLoading(true)
            translateMessage(id, message)
          }}
          className={`w-9 h-5 ${translated ? 'text-darkRed' : 'text-slateGray'} ml-1 cursor-pointer flex items-center`}>
          {isLoading ? <Loader isLoading /> : <Translate />}
        </div>
        <div className={`bg-coolGray rounded-2xl p-2 text-white text-14 max-w-[80%] ${borderStyles}`}>{message}</div>
      </div>
      <div className="h-2" />
    </div>
  )
}

export default SentMessage
